import Button, { ButtonModeE } from "../../components/Button/Button";
import { H1 } from "../../components/Text/Text";
import SendForCustomerApproval from "./SendForCustomerApproval";

import styles from "./sendForCustomerApproval.module.scss";

const SendForCustomerApprovalPopup = (removePopup: () => void, campaignId: number) => ({
  header: <H1>Sent campaign for customer approval</H1>,
  body: (
    <SendForCustomerApproval
      removePopup={removePopup}
      campaignId={campaignId}
    />
  ),
  footer: (
    <div className={styles.footerButtonsWrapper}>
      <Button onClick={removePopup} mode={ButtonModeE.OUTLINED}>
        Cancel
      </Button>
      <Button form="send-for-customer-approval" useGlobalLoading>
        Send
      </Button>
    </div>
  ),
  className: styles.popupWrapper,
});

export default SendForCustomerApprovalPopup;